import { render, staticRenderFns } from "./IngestionStatusBadge.vue?vue&type=template&id=6a6fe50c&scoped=true"
import script from "./IngestionStatusBadge.vue?vue&type=script&lang=ts"
export * from "./IngestionStatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./IngestionStatusBadge.vue?vue&type=style&index=0&id=6a6fe50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6fe50c",
  null
  
)

export default component.exports